import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import './TableDialog.css'
Modal.setAppElement('#root'); // Set the root element for accessibility

function TableDialog({ policy, isOpen, setIsOpen }) {
    const toggleModal = () => {
        setIsOpen(!isOpen);
    };
    const tableRef = useRef(null);
    useEffect(() => {
        function handleClickOutside(event) {
            if (tableRef.current && !tableRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <>
            {
                isOpen && (
                    <div className="dialog-table-overlay">
                        {/* <div ref={tableRef} className="dialog-table"> */}
                        <div ref={tableRef} className="dialog-content">
                            <div className="box-table-list" style={{ backgroundColor: "#FFEDB1", textAlign: "-webkit-center", textAlign: "-moz-center" }}>
                                <div className='header-span-customer' style={{ textAlign: "center", fontWeight: "bold" }}>
                                    <span>Thông tin đại lý</span>
                                </div>
                                <table border="1">
                                    <tr>
                                        <th>Số hợp đồng bảo hiểm</th>
                                        <td><span className='span-table-dialog description-small-customer'>{policy.poNumber}</span></td>
                                    </tr>
                                    <tr>
                                        <th>Đại lý phục vụ hợp đồng</th>
                                        <td><span className='span-table-dialog description-small-customer'>{policy.agentName}</span></td>
                                    </tr>
                                    <tr>
                                        <th>Mã số đại lý</th>
                                        <td><span className='span-table-dialog description-small-customer'>{policy.agentNumber}</span></td>
                                    </tr>
                                    <tr>
                                        <th>Số điện thoại</th>
                                        <td><span className='span-table-dialog description-small-customer'>{policy.agentPhone}</span></td>
                                    </tr>
                                    <tr>
                                        <th>Địa chỉ liên hệ</th>
                                        <td><span className='span-table-dialog description-small-customer'>{policy.agentAddress}</span></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        {/* </div> */}
                    </div>)
            }
        </>
    );
}

export default TableDialog;